import React, {forwardRef, useImperativeHandle} from 'react'
import imagesStyle from './index.module.scss'
import { ImageViewer, Toast } from 'antd-mobile'
// import classNames from 'classnames'
const ImageViewer_ = (props, ref) => {
  // image必传当前图片 imageList所有图片列表 urlKey图片选取字段
  const { className = '', style = {}, image = {}, imageList = [], urlKey = 'thumb_l', urlSourceKey = 'thumb_l', fit = 'none', renderFooter = ()=>{return null} } = props

  const _src = image[urlKey] || ''
  let _imageList = []
  if (imageList && imageList.length) {
    _imageList = imageList.map(v => {
      return v[urlSourceKey] || ''
    })
  }

  const getDefaultIndex = () => {
    const index = _imageList.indexOf(_src)
    return index >= 0 ? index : 0
  }

  // 暴露给外部的方法
  useImperativeHandle(ref, () => ({
    clear: () => {
      ImageViewer.clear()
    },
  }))

  const clickHandler = e => {
    e.preventDefault()
    Toast.show({
      icon: 'loading',
      duration: 0,
    })
    const promiseAll = []
    const img = []
    const imgTotal = _imageList.length

    for (let i = 0; i < imgTotal; i++) {
      promiseAll[i] = new Promise(resolve => {
        img[i] = new Image()
        img[i].src = _imageList[i]
        img[i].onload = function () {
          resolve(this)
        }
      })
    }
    Promise.all(promiseAll).then(() => {
      Toast.clear()
      if (_imageList.length > 1) {
        ImageViewer.Multi.show({
          images: _imageList,
          defaultIndex: getDefaultIndex(),
          renderFooter,
        })
      } else {
        ImageViewer.show({
          image: _imageList[0] || _src,
          renderFooter,
        })
      }
    })
  }

  const getStyle = () => {
    let res = { ...style }
    const { width, height } = style
    if (!(width || height)) {
      res = { ...style }
    }
    return res
  }

  const getVnode = () => {
    let res
    if (fit === 'none') {
      res = <img className={`${className}`}
          onClick={clickHandler}
          src={_src}
          style={getStyle()} />
    } else {
      res = <div className={`${imagesStyle.img} ${className}`}
          onClick={clickHandler}
          style={{ background: `url("${_src}") no-repeat`, width: '100%', height: '100%', backgroundPosition: 'center', backgroundSize: 'contain', ...style }}
      />
    }
    return res
  }

  return (
    getVnode()
  )
}
export default forwardRef(ImageViewer_)